// В.2.b: Дрон-спасатель (liv_dron_spasatel, common, 1/0/4).
// [Аура]: лечит юнита слева и юнита справа от себя на той же линии на +1 ХП.
//
// Геометрия соседства — как у Цепи командования: line=line, slot ∈ {idx-1, idx+1}.
// Если соседний слот пуст / юнит не существует — просто пропускаем.
// Себя НЕ лечит (диздок 7.4).
// Героя НЕ лечит (соседство только по слотам линии).
// Срабатывает в обоих раундах хил-прохода Ф3 (round 1 и 2).
// Молчание блокирует — это уже в каркасе runLivLifeHealAuras (heal-auras.js).

import { registerLivLifeHealAura } from './heal-auras.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_dron_spasatel';
const HEAL_AMOUNT = 1;

registerImplementedAbility(CARD_ID, 'passive');

registerLivLifeHealAura(CARD_ID, (state, card, _round) => {
  const owner = state.players?.[card.ownerId];
  if (!owner) return;
  const line = card.line, slot = card.slot;
  if (line == null || slot == null) return;
  for (const dx of [-1, 1]) {
    const nidx = slot + dx;
    if (nidx < 0 || nidx > 3) continue;
    const neighbor = owner.field?.[line]?.[nidx];
    if (!neighbor || neighbor === card) continue;
    if (!neighbor.isAlive || !neighbor.isAlive()) continue;
    healUnit(state, neighbor, HEAL_AMOUNT, card);
  }
});
